// Custom Collection Filters - Metafield-driven filter system

function shouldUseCustomFilterTabsAbove() {
  return Boolean(document.querySelector('.custom-collection-filters-above .custom-collection-filters'));
}

function repositionDesktopFilters() {
  const facetsVertical = document.querySelector('.facets-vertical.page-width');
  if (!facetsVertical) return;

  if (facetsVertical.firstElementChild && facetsVertical.firstElementChild.classList.contains('custom-collection-filters-above')) {
    return;
  }

  const desktopFilters = document.querySelector('.product-grid-wrapper .custom-collection-filters-desktop');
  if (!desktopFilters) return;

  if (desktopFilters.dataset.repositioned === 'true') return;

  const filtersWrapper = document.createElement('div');
  filtersWrapper.className = 'custom-collection-filters-above';

  filtersWrapper.appendChild(desktopFilters);

  facetsVertical.insertBefore(filtersWrapper, facetsVertical.firstChild);

  desktopFilters.dataset.repositioned = 'true';
}

/* HVAC-AI-055 */
const customFiltersPreserveTabByPath = Object.create(null);

function rememberCustomFiltersTab(button) {
  const root = button.closest('.custom-collection-filters');
  const panel = button.closest('.custom-filter-panel');
  if (!root || !panel || !panel.dataset.filter) return;
  customFiltersPreserveTabByPath[window.location.pathname] = panel.dataset.filter;
}

function consumePreservedCustomFiltersTab() {
  const key = window.location.pathname;
  const tabKey = customFiltersPreserveTabByPath[key];
  if (tabKey) delete customFiltersPreserveTabByPath[key];
  return tabKey || null;
}

function applyTabAndPanelForKey(customFilters, tabKey, tabs, panels) {
  if (!tabKey) return false;
  tabs.forEach((t) => {
    t.classList.remove('active');
    t.setAttribute('aria-expanded', 'false');
  });
  panels.forEach((p) => p.classList.remove('active'));
  const targetTab = customFilters.querySelector(`[data-tab="${tabKey}"]`);
  const targetPanel = customFilters.querySelector(`[data-filter="${tabKey}"]`);
  if (targetTab && targetPanel) {
    targetTab.classList.add('active');
    targetTab.setAttribute('aria-expanded', 'true');
    targetPanel.classList.add('active');
    return true;
  }
  return false;
}

/**
 * One active value per Shopify facet param (per custom tab). Build params with this param replaced/removed.
 */
function copyUrlParamsExceptParam(currentParams, paramToDrop) {
  const newParams = new URLSearchParams();
  currentParams.forEach((value, key) => {
    if (key === paramToDrop) return;
    newParams.append(key, value);
  });
  return newParams;
}

function canRenderCollectionViaFacets() {
  return (
    typeof FacetFiltersForm !== 'undefined' &&
    typeof FacetFiltersForm.renderPage === 'function' &&
    document.getElementById('product-grid') &&
    document.getElementById('ProductGridContainer')
  );
}

function syncCustomFiltersAfterFacetRender() {
  document.querySelectorAll('.custom-collection-filters').forEach((container) => {
    container.dataset.userInteracting = 'false';
  });
  document.querySelectorAll('.custom-filter-button').forEach((btn) => {
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
  });
  // Keep dataset.initialized — full reinit would stack MutationObservers inside initializeCustomCollectionFilters.
  initializeCustomCollectionFilters();
  repositionDesktopFilters();
}

function resetCustomFilterButtonLoadingState() {
  document.querySelectorAll('.custom-filter-button').forEach((btn) => {
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
  });
}

document.addEventListener('facetFilters:rendered', syncCustomFiltersAfterFacetRender);
document.addEventListener('facetFilters:fetchError', resetCustomFilterButtonLoadingState);

document.addEventListener('DOMContentLoaded', () => {
  repositionDesktopFilters();
});
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(repositionDesktopFilters, 0);
}
function getFilterKeywords() {
  const customFilters = document.querySelector('.custom-collection-filters');
  if (!customFilters) return [];
  
  const keywordsData = customFilters.dataset.filterKeywords;
  if (!keywordsData) return [];
  
  // Parse the keywords: "Label: keyword||Label2: keyword2" (skip tag lines: "Group: tag [ ... ]")
  const keywords = [];
  const entries = keywordsData.split('||');
  
  entries.forEach(entry => {
    if (entry.includes(' tag [')) return; // tag-based line, not a filter keyword
    const parts = entry.split(':');
    if (parts.length >= 2) {
      const keyword = parts[1].trim();
      if (keyword) {
        keywords.push(keyword);
      }
    }
  });
  
  return keywords;
}

function initializeCustomCollectionFilters() {
  const customFiltersContainers = document.querySelectorAll('.custom-collection-filters');
  
  if (!customFiltersContainers.length) {
    return;
  }

  customFiltersContainers.forEach((customFilters, index) => {
    // Check if user is currently interacting with tabs
    if (customFilters.dataset.userInteracting === 'true') {
      return; // Skip reinitialization during user interaction
    }
    
    // More robust initialization check
    if (customFilters.dataset.initialized === 'true') {
      // If already initialized, just update the active states without duplicating
      updateActiveStatesOnly(customFilters);
      return;
    }
    
    customFilters.dataset.initialized = 'true';
    
    const tabs = customFilters.querySelectorAll('.custom-filter-tab');
    const panels = customFilters.querySelectorAll('.custom-filter-panel');
    const customButtons = customFilters.querySelectorAll('.custom-filter-button');
    
    // Clear any existing event listeners by cloning elements
    clearExistingListeners(customFilters, tabs, customButtons);
    
    // Get fresh references after cloning
    const freshTabs = customFilters.querySelectorAll('.custom-filter-tab');
    const freshPanels = customFilters.querySelectorAll('.custom-filter-panel');
    const freshButtons = customFilters.querySelectorAll('.custom-filter-button');
    
    // Initialize active states and tab selection
    initializeActiveStates(customFilters, freshTabs, freshPanels, freshButtons);
    
    // Add event listeners to fresh elements
    addEventListeners(customFilters, freshTabs, freshPanels, freshButtons);
  });

  function clearExistingListeners(container, tabs, buttons) {
    // Clone and replace tabs to remove old event listeners
    tabs.forEach(tab => {
      const newTab = tab.cloneNode(true);
      tab.parentNode.replaceChild(newTab, tab);
    });
    
    // Clone and replace buttons to remove old event listeners
    buttons.forEach(button => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
    });
  }

  function updateActiveStatesOnly(customFilters) {
    const tabs = customFilters.querySelectorAll('.custom-filter-tab');
    const panels = customFilters.querySelectorAll('.custom-filter-panel');
    const customButtons = customFilters.querySelectorAll('.custom-filter-button');
    
    // Reset button states
    customButtons.forEach(button => {
      button.dataset.isActive = 'false';
      button.classList.remove('active');
    });
    
    // Check URL and update active states
    const urlParams = new URLSearchParams(window.location.search);
    let activeTabFromUrl = null;
    
    urlParams.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        let decodedValue;
        try {
          decodedValue = decodeURIComponent(value);
        } catch (e) {
          decodedValue = value;
        }
        customButtons.forEach(button => {
          if (button.dataset.filterParam === key && button.dataset.filterValue === decodedValue) {
            button.dataset.isActive = 'true';
            button.classList.add('active');
            
            const buttonPanel = button.closest('.custom-filter-panel');
            if (buttonPanel) {
              activeTabFromUrl = buttonPanel.dataset.filter;
            }
          }
        });
      }
    });
    
    // Update tab states
    if (activeTabFromUrl) {
      if (applyTabAndPanelForKey(customFilters, activeTabFromUrl, tabs, panels)) {
        const targetTab = customFilters.querySelector(`[data-tab="${activeTabFromUrl}"]`);
        if (targetTab && customFilters.dataset.userInteracting !== 'true') {
          scrollTabIntoView(targetTab);
        }
      }
    } else {
      const preservedTab = consumePreservedCustomFiltersTab();
      if (preservedTab && applyTabAndPanelForKey(customFilters, preservedTab, tabs, panels)) {
        const targetTab = customFilters.querySelector(`[data-tab="${preservedTab}"]`);
        if (targetTab && customFilters.dataset.userInteracting !== 'true') {
          scrollTabIntoView(targetTab);
        }
      } else {
        const currentActiveTab = customFilters.querySelector('.custom-filter-tab.active');
        const currentActivePanel = customFilters.querySelector('.custom-filter-panel.active');
        
        if (!currentActiveTab || !currentActivePanel) {
          if (tabs.length > 0 && panels.length > 0) {
            tabs.forEach(t => {
              t.classList.remove('active');
              t.setAttribute('aria-expanded', 'false');
            });
            panels.forEach(p => p.classList.remove('active'));
            
            tabs[0].classList.add('active');
            tabs[0].setAttribute('aria-expanded', 'true');
            panels[0].classList.add('active');
            
            if (customFilters.dataset.userInteracting !== 'true') {
              scrollTabIntoView(tabs[0]);
            }
          }
        } else {
          if (customFilters.dataset.userInteracting !== 'true') {
            scrollTabIntoView(currentActiveTab);
          }
        }
      }
    }
  }

  function initializeActiveStates(customFilters, tabs, panels, buttons) {
    // Always reset all buttons first
    buttons.forEach(button => {
      button.dataset.isActive = 'false';
      button.classList.remove('active');
    });
    
    // Check URL for active filters and mark only those buttons as active
    const urlParams = new URLSearchParams(window.location.search);
    let activeTabFromUrl = null;
    
    urlParams.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        let decodedValue;
        try {
          decodedValue = decodeURIComponent(value);
        } catch (e) {
          decodedValue = value;
        }
        buttons.forEach(button => {
          if (button.dataset.filterParam === key && button.dataset.filterValue === decodedValue) {
            button.dataset.isActive = 'true';
            button.classList.add('active');
            
            // Find which tab this button belongs to
            const buttonPanel = button.closest('.custom-filter-panel');
            if (buttonPanel) {
              activeTabFromUrl = buttonPanel.dataset.filter;
            }
          }
        });
      }
    });
    
    // Set the correct active tab based on URL parameters
    if (activeTabFromUrl) {
      if (applyTabAndPanelForKey(customFilters, activeTabFromUrl, tabs, panels)) {
        const targetTab = customFilters.querySelector(`[data-tab="${activeTabFromUrl}"]`);
        if (targetTab && customFilters.dataset.userInteracting !== 'true') {
          scrollTabIntoView(targetTab);
        }
      }
    } else {
      const preservedTab = consumePreservedCustomFiltersTab();
      if (preservedTab && applyTabAndPanelForKey(customFilters, preservedTab, tabs, panels)) {
        const targetTab = customFilters.querySelector(`[data-tab="${preservedTab}"]`);
        if (targetTab && customFilters.dataset.userInteracting !== 'true') {
          scrollTabIntoView(targetTab);
        }
        return;
      }
      const currentActiveTab = customFilters.querySelector('.custom-filter-tab.active');
      const currentActivePanel = customFilters.querySelector('.custom-filter-panel.active');
      
      if (currentActiveTab && currentActivePanel) {
        // Keep the current tab active and ensure it's visible
        if (customFilters.dataset.userInteracting !== 'true') {
          scrollTabIntoView(currentActiveTab);
        }
        return;
      } else {
        // No tab is currently active, show the first tab by default
        if (tabs.length > 0 && panels.length > 0) {
          tabs.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-expanded', 'false');
          });
          panels.forEach(p => p.classList.remove('active'));
          
          tabs[0].classList.add('active');
          tabs[0].setAttribute('aria-expanded', 'true');
          panels[0].classList.add('active');
          
          // Only scroll first tab into view if user is not interacting
          if (customFilters.dataset.userInteracting !== 'true') {
            scrollTabIntoView(tabs[0]);
          }
        }
      }
    }
  }

  function scrollTabIntoView(tab) {
    if (!tab) return;
    
    // Check if we're on mobile (screen width <= 768px)
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      const tabsContainer = tab.closest('.custom-filter-tabs');
      if (tabsContainer) {
        // Get tab position relative to container
        const tabRect = tab.getBoundingClientRect();
        const containerRect = tabsContainer.getBoundingClientRect();
        
        // Calculate if tab is outside visible area
        const tabLeftEdge = tabRect.left - containerRect.left;
        const tabRightEdge = tabRect.right - containerRect.left;
        const containerWidth = containerRect.width;
        
        // If tab is outside visible area, scroll to center it
        if (tabLeftEdge < 0 || tabRightEdge > containerWidth) {
          const scrollLeft = tab.offsetLeft - (containerWidth / 2) + (tab.offsetWidth / 2);
          tabsContainer.scrollTo({
            left: Math.max(0, scrollLeft),
            behavior: 'smooth'
          });
        }
      }
    }
  }

  function addEventListeners(customFilters, tabs, panels, buttons) {
    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', function() {
        // Set flag to prevent reinitialization during user interaction
        customFilters.dataset.userInteracting = 'true';
        
        const targetTab = this.dataset.tab;
        
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-expanded', 'false');
        });
        panels.forEach(p => p.classList.remove('active'));
        
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        
        const targetPanel = customFilters.querySelector(`[data-filter="${targetTab}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
        
        // Scroll clicked tab into view on mobile
        scrollTabIntoView(this);
        
        // Clear the interaction flag after a short delay
        setTimeout(() => {
          customFilters.dataset.userInteracting = 'false';
        }, 500);
      });
    });

    buttons.forEach((button, buttonIndex) => {
      button.addEventListener('click', function() {
        const isActive = this.dataset.isActive === 'true';
        if (isActive) {
          rememberCustomFiltersTab(this);
        }

        const filterParam = this.dataset.filterParam;
        const filterValue = this.dataset.filterValue;
        const currentParams = new URLSearchParams(window.location.search);

        let targetUrl;

        if (isActive) {
          const newParams = copyUrlParamsExceptParam(currentParams, filterParam);
          targetUrl = newParams.toString()
            ? `${window.location.pathname}?${newParams.toString()}`
            : window.location.pathname;
        } else {
          const newParams = copyUrlParamsExceptParam(currentParams, filterParam);
          newParams.append(filterParam, filterValue);
          targetUrl = `${window.location.pathname}?${newParams.toString()}`;
        }

        this.style.opacity = '0.6';
        this.style.pointerEvents = 'none';

        const queryString = targetUrl.includes('?') ? targetUrl.slice(targetUrl.indexOf('?') + 1) : '';

        if (canRenderCollectionViaFacets()) {
          FacetFiltersForm.renderPage(queryString, null, true);
        } else {
          window.location.href = targetUrl;
        }
      });
    });

    buttons.forEach(button => {
      button.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener('keydown', function(e) {
        let nextIndex;
        
        switch(e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            // Set interaction flag
            customFilters.dataset.userInteracting = 'true';
            nextIndex = index > 0 ? index - 1 : tabs.length - 1;
            tabs[nextIndex].click();
            tabs[nextIndex].focus();
            // Scroll the new active tab into view
            scrollTabIntoView(tabs[nextIndex]);
            break;
          case 'ArrowRight':
            e.preventDefault();
            // Set interaction flag
            customFilters.dataset.userInteracting = 'true';
            nextIndex = index < tabs.length - 1 ? index + 1 : 0;
            tabs[nextIndex].click();
            tabs[nextIndex].focus();
            // Scroll the new active tab into view
            scrollTabIntoView(tabs[nextIndex]);
            break;
          case 'Home':
            e.preventDefault();
            // Set interaction flag
            customFilters.dataset.userInteracting = 'true';
            tabs[0].click();
            tabs[0].focus();
            // Scroll the first tab into view
            scrollTabIntoView(tabs[0]);
            break;
          case 'End':
            e.preventDefault();
            // Set interaction flag
            customFilters.dataset.userInteracting = 'true';
            tabs[tabs.length - 1].click();
            tabs[tabs.length - 1].focus();
            // Scroll the last tab into view
            scrollTabIntoView(tabs[tabs.length - 1]);
            break;
        }
        
        // Clear interaction flag after navigation
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
          setTimeout(() => {
            customFilters.dataset.userInteracting = 'false';
          }, 500);
        }
      });
    });
  }
  
  // Call the helper functions for filter hiding

  function hideCustomFilterActiveFacets() {
    if (!shouldUseCustomFilterTabsAbove()) return;

    const activeFacetsContainers = document.querySelectorAll('.active-facets, .active-facets-mobile');
    
    // Get filter keywords from the custom-collection-filters element
    const filterKeywords = getFilterKeywords();
    
    if (filterKeywords.length === 0) return;
    
    activeFacetsContainers.forEach(container => {
      const activeFacetButtons = container.querySelectorAll('.active-facets__button');
      
      activeFacetButtons.forEach(button => {
        const buttonText = button.textContent.toLowerCase();
        
        const isCustomFilter = filterKeywords.some(keyword => 
          buttonText.includes(keyword.toLowerCase())
        );
        
        if (isCustomFilter) {
          button.style.display = 'none';
        }
      });
    });
  }

  // Hide original Shopify filters for our custom categories
  function hideOriginalFilters() {
    if (!shouldUseCustomFilterTabsAbove()) return;

    const filterKeywords = getFilterKeywords();
    
    if (filterKeywords.length === 0) return;
    
    // Hide desktop filters
    const desktopFilters = document.querySelectorAll('.facets__disclosure-vertical');
    desktopFilters.forEach(filter => {
      const filterLabel = filter.querySelector('.facets__summary-label');
      if (filterLabel) {
        const labelText = filterLabel.textContent.toLowerCase();
        const shouldHide = filterKeywords.some(keyword => 
          labelText.includes(keyword.toLowerCase())
        );
        if (shouldHide) {
          filter.style.display = 'none';
          // Ensure the filter is not interfering with page functionality
          filter.style.pointerEvents = 'none';
        }
      }
    });
    
    // Hide mobile filters
    const mobileFilters = document.querySelectorAll('.mobile-facets__details');
    mobileFilters.forEach(filter => {
      const filterSummary = filter.querySelector('.mobile-facets__summary');
      if (filterSummary) {
        const summaryText = filterSummary.textContent.toLowerCase();
        const shouldHide = filterKeywords.some(keyword => 
          summaryText.includes(keyword.toLowerCase())
        );
        if (shouldHide) {
          filter.style.display = 'none';
          filter.style.pointerEvents = 'none';
        }
      }
    });
  }

  hideOriginalFilters();
  hideCustomFilterActiveFacets();
  
  // Add a small delay to ensure DOM is fully ready
  setTimeout(() => {
    hideOriginalFilters();
    hideCustomFilterActiveFacets();
  }, 100);
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        setTimeout(() => {
          hideOriginalFilters();
          hideCustomFilterActiveFacets();
        }, 50);
      }
    });
  });
  
  document.querySelectorAll('.active-facets, .active-facets-mobile').forEach(container => {
    observer.observe(container, { childList: true, subtree: true });
  });
  
  // Also observe the main facets containers
  document.querySelectorAll('.facets__form-vertical, .mobile-facets__main').forEach(container => {
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }
  });
  
  // Watch for when Shopify AJAX loads new content
  window.addEventListener('shopify:section:load', function() {
    setTimeout(() => {
      hideOriginalFilters();
      hideCustomFilterActiveFacets();
    }, 100);
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initializeCustomCollectionFilters);

// Re-initialize after a short delay on page load
window.addEventListener('load', function() {
  setTimeout(initializeCustomCollectionFilters, 200);
});

// Re-initialize when history changes (back/forward buttons)
window.addEventListener('popstate', function() {
  // FORCE reset initialization flags and button states
  document.querySelectorAll('.custom-collection-filters').forEach(container => {
    container.dataset.initialized = 'false';
    container.dataset.userInteracting = 'false'; // Reset interaction flag
    
    // Also immediately reset all button states
    const buttons = container.querySelectorAll('.custom-filter-button');
    buttons.forEach(button => {
      button.dataset.isActive = 'false';
      button.classList.remove('active');
      button.style.opacity = '';
      button.style.pointerEvents = '';
    });
  });
  setTimeout(initializeCustomCollectionFilters, 200);
});

// Listen for Shopify's AJAX navigation events
document.addEventListener('DOMContentLoaded', function() {
  // Watch for URL changes that don't trigger popstate
  let currentUrl = window.location.href;
  
  setInterval(function() {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      
      // FORCE reset initialization flags and button states
      document.querySelectorAll('.custom-collection-filters').forEach(container => {
        container.dataset.initialized = 'false';
        container.dataset.userInteracting = 'false'; // Reset interaction flag
        
        // Also immediately reset all button states
        const buttons = container.querySelectorAll('.custom-filter-button');
        buttons.forEach(button => {
          button.dataset.isActive = 'false';
          button.classList.remove('active');
          button.style.opacity = '';
          button.style.pointerEvents = '';
        });
      });
      
      setTimeout(initializeCustomCollectionFilters, 300);
    }
  }, 500);
});

// Listen for Shopify section reloads
document.addEventListener('shopify:section:load', function(event) {
  setTimeout(() => {
    repositionDesktopFilters();
    initializeCustomCollectionFilters();
  }, 100);
});

// Listen for when collection content is updated
const observer = new MutationObserver(function(mutations) {
  let shouldReinit = false;
  
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Check if collection content was updated
      Array.from(mutation.addedNodes).forEach(node => {
        if (node.nodeType === 1 && (
          node.classList && node.classList.contains('collection') ||
          node.querySelector && node.querySelector('.collection')
        )) {
          shouldReinit = true;
        }
      });
    }
  });
  
  if (shouldReinit) {
    // FORCE reset initialization flags and button states
    document.querySelectorAll('.custom-collection-filters').forEach(container => {
      container.dataset.initialized = 'false';
      container.dataset.userInteracting = 'false'; // Reset interaction flag
      
      // Also immediately reset all button states
      const buttons = container.querySelectorAll('.custom-filter-button');
      buttons.forEach(button => {
        button.dataset.isActive = 'false';
        button.classList.remove('active');
        button.style.opacity = '';
        button.style.pointerEvents = '';
      });
    });
    setTimeout(() => {
      repositionDesktopFilters();
      initializeCustomCollectionFilters();
    }, 200);
  }
});

// Start observing the document for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Fallback: Check every 2 seconds if custom filters need initialization
setInterval(function() {
  const containers = document.querySelectorAll('.custom-collection-filters');
  let needsInit = false;
  
  containers.forEach(container => {
    if (container.dataset.initialized !== 'true') {
      needsInit = true;
    }
  });
  
  if (needsInit && containers.length > 0) {
    repositionDesktopFilters();
    initializeCustomCollectionFilters();
  }
}, 2000);
